<div (click) = "downloadOnClick()"><span class="hyperlink"
>{{fileTitle}}</span>
</div>